module.exports = __webpack_public_path__ + "img/logout.8217d7ea.png";